import { EXCHANGE_META } from 'consts'
import images from 'images'

export const getSpiritImage = (a: string) =>
  require(`../images/spirits/${a}.png`)

export const getSpiritSpecsImage = (a: string) =>
  require(`../images/spirits/${a}-specs.png`)

export const getExchangeMeta = (a: string) => EXCHANGE_META[a]

export const getBadgeImage = (a: number) => {
  if (a === 0) return images.badges.gold
  if (a === 1) return images.badges.silver
  return images.badges.bronze
}
